"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _client = require("@apollo/client");
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _lodash = _interopRequireDefault(require("lodash.range"));
var _link = _interopRequireDefault(require("next/link"));
var _react = _interopRequireDefault(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactIntl = require("react-intl");
var _activitySearchParams = _interopRequireDefault(require("../constants/activitySearchParams"));
var _parseToDateString = _interopRequireDefault(require("../constants/parseToDateString"));
var _graphql = require("../generated/graphql");
var _useQueryParams = _interopRequireDefault(require("../hooks/useQueryParams"));
var _removeUndefinedEntries = _interopRequireDefault(require("../utils/removeUndefinedEntries"));
var _ActivityHit = _interopRequireDefault(require("./ActivityHit"));
var _ActivityTile = _interopRequireDefault(require("./ActivityTile"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Carousel = _interopRequireWildcard(require("./designsystem/Carousel"));
var _Section = _interopRequireDefault(require("./designsystem/Section"));
var _Tile = require("./designsystem/Tile");
var _TenantContext = require("../context/TenantContext");
var _router = require("next/router");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const query = exports.query = (0, _client.gql)`
    query ActivityAtlternatives(
        $params: ActivitySearchParamsInput!
        $limit: Int
        $startDate: String!
        $endDate: String!
    ) {
        activities(params: $params, limit: $limit) {
            hits {
                ...ActivityHit
            }
        }
    }
`;
const LIMIT = 12;
const ActivityAlternatives = ({
  currentActivitySlug
}) => {
  const [{
    startDate,
    endDate,
    placeId,
    targetAudiences,
    themeSlugs
  }] = (0, _useQueryParams.default)(_activitySearchParams.default);
  const {
    locale
  } = (0, _router.useRouter)();
  const dateVars = {
    startDate: startDate ?? (0, _parseToDateString.default)(new Date()),
    endDate: endDate ?? (0, _parseToDateString.default)((0, _endOfMonth.default)(new Date()))
  };
  const [ref, inView] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: '500px'
  });
  const {
    data,
    loading
  } = (0, _graphql.useActivityAtlternativesQuery)({
    skip: !inView,
    variables: _objectSpread({
      limit: LIMIT,
      params: _objectSpread(_objectSpread({}, dateVars), {}, {
        targetAudiences: targetAudiences,
        placeId,
        themeSlugs
      })
    }, dateVars),
    ssr: false
  });
  const sizes = (0, _Tile.useTileImageSizes)();
  const queryParams = (0, _removeUndefinedEntries.default)({
    startDate,
    endDate,
    targetAudiences,
    themeSlugs,
    placeId
  });
  const hits = data?.activities.hits.filter(activity => activity.slug !== currentActivitySlug);
  const showAlternatives = hits && hits.length > 0;
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  return __jsx(_Section.default, {
    name: "alternatives",
    ref: ref
  }, showAlternatives && __jsx(_ContentWrapper.default, null, __jsx(_react.default.Fragment, null, __jsx(_Carousel.default, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "KMhlpN",
      defaultMessage: [{
        "type": 0,
        "value": "Probeer ook eens"
      }]
    }),
    continuous: true
  }, loading && (0, _lodash.default)(4).map(i => __jsx(_Carousel.CarouselChild, {
    key: i
  }, __jsx(_ActivityTile.default, {
    loading: true
  }))), !loading && hits?.map(hit => __jsx(_Carousel.CarouselChild, {
    key: hit.name
  }, __jsx(_ActivityHit.default, {
    sizes: sizes,
    hit: hit
  })))), __jsx(_ContentWrapper.default, {
    style: {
      paddingTop: 0
    }
  }, __jsx(_link.default, {
    passHref: true,
    href: {
      pathname: brandConfig?.customSlugs?.agenda?.[locale] ? `/${brandConfig?.customSlugs?.agenda?.[locale]}` : '/agenda',
      query: _objectSpread({
        view: startDate === endDate ? 'day' : 'month'
      }, queryParams)
    },
    legacyBehavior: true
  }, __jsx(_Button.default, {
    style: {
      display: 'inline-flex'
    },
    variant: "outline",
    as: "a"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "9LMYqm",
    defaultMessage: [{
      "type": 0,
      "value": "Meer activiteiten bekijken"
    }]
  })))))));
};
var _default = exports.default = ActivityAlternatives;